import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { DialogService } from '@nrwl/dialog-service';
import { RxBadgeModule } from '@nrwl/rx-badge';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxColModule } from '@nrwl/rx-col';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxRowModule } from '@nrwl/rx-row';

@Component({
  selector: 'rx-bottom-bar-composite',
  templateUrl: './rx-bottom-bar-composite.component.html',
  styleUrls: ['./rx-bottom-bar-composite.component.scss'],
  imports: [
    CommonModule,
    RxColModule,
    RxRowModule,
    RxIconModule,
    FormsModule,
    MatToolbarModule,
    RxButtonModule,
    RxBadgeModule,
    MatTooltipModule,
  ],
})
export class RxBottomBarCompositeComponent implements OnInit {
  @Input() item: any[] = [];
  @Input() deselectable = true;
  @Input() forceShow = false;
  @Input() counter = true;
  @Input() iconClose: string;
  @Input() selectedTitle: any = 'forms selected';
  @Output() deselect = new EventEmitter<boolean>();
  @Output() help = new EventEmitter<any>();
  @Output() itemChange = new EventEmitter<any>();

  constructor(public dialogService: DialogService) {}

  ngOnInit() {}

  onHelp() {
    this.help.emit();
  }

  deselectTemplatesClicked() {
    if (this.item.length > 0) {
      this.deselect.emit();
    }
  }
}
